import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/ProfilePage.css";
import richesseImage from "../../images/richesse.ico";
import ProfileTab from "./profile-tabs/ProfileTab.js";
import KYCTab from "./profile-tabs/KYCTab.js";
import SettingsTab from "./profile-tabs/SettingsTab.js";
import PaymentDetailsTab from "./profile-tabs/PaymentDetails.js";
import Referral from "./profile-tabs/Referral.js";
import { useProfile } from "../../services/hooks/getApi.js";
import { ShimmerThumbnail } from "react-shimmer-effects";
import LockAccount from "../../images/locked-card.png"; 
import AgreementTab from "./profile-tabs/AgreementTab.js";

// ProfileCard Component==========================================
const ProfileCard = () => {
  const [fetchLoading, setFetchLoading] = useState(true);

  // getting profile data
  const { data: profile, isLoading } = useProfile();

  useEffect(() => {
    if (!isLoading) {
      setFetchLoading(false);
    }
  }, [isLoading]);

  useEffect(() => {
    document.title = "Profile | Bitstek Advisory"; // Set the document title
  }, []);


  const KYCStatus = profile?.KYC_Status || "Pending"; // Default value if undefined
  const Email = profile?.isEmailVerified ? "Verified" : "Not Verified";

  return (
    <>
      <div className="card profile-card text-center">
        {fetchLoading ? (
          <div className="shimmer-container">
            <div className="shimmer-effect">
              <ShimmerThumbnail row={2} col={2} card frameHeight={1000} />
            </div>
          </div>
        ) : (
          <div className="card-body">
            {profile?.isFreezed && (
              <img src={LockAccount} alt="Locked Account" className="lockIMG" />
            )}
            <div className="pro-img">
              <img src={richesseImage} alt="Profile" />
            </div>
            <h3 className="pb-2 profile-name">
              {profile?.FullName || "Guest"}
            </h3>
            <hr />
            <div className="row">
              {/* <Col className="side-border"> */}
              <div className="col-md-6 col-sm-12 col-6 border-right">
                <small>
                  <b>Email:</b>
                </small>
                <br />
                <p className="status-text">
                  <span className="status_label verified">
                    {Email ? "verified" : "NotVerified"}
                  </span>
                </p>
              </div>
              {/* </Col> */}
              <div className="col-md-6 col-sm-12 col-6">
                <small>
                  <b>KYC Status:</b>
                </small>
                <br />
                <p className="status-text">
                  <span
                    className={`status_label ${
                      KYCStatus === "Pending"
                        ? "pending"
                        : KYCStatus === "Rejected"
                        ? "Rejected"
                        : "verified"
                    }`}>
                    {KYCStatus}
                  </span>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

// Profile Component
const ProfilePage = () => {
  const [activeTab, setActiveTab] = useState("KYC");

  return (
    <>
      <div className="transactions-history">
        <div className="row mt-3">
          <div className="col-lg-4 col-md-4 col-xs-12">
            <ProfileCard />
          </div>

          <div className="col-lg-8 col-md-8 col-xs-12">
            <p id="Page_MsgBox"></p>
            <div className="card1">
              <ul className="nav nav-tabs profile-tab" role="tablist">
                {[
                  "KYC",
                  "Profile",
                  "Settings",
                  "Payment-Details",
                  "Referral",
                  "Agreements",
                ].map((tab) => (
                  <li className="nav-item" key={tab}>
                    <button
                      className={`nav-link ${
                        activeTab === tab ? "active" : ""
                      }`}
                      onClick={() => setActiveTab(tab)}>
                      {tab}
                    </button>
                  </li>
                ))}
              </ul>

              <div className="tab-content">
                {activeTab === "KYC" && <KYCTab />}
                {activeTab === "Profile" && <ProfileTab />}
                {activeTab === "Settings" && <SettingsTab />}
                {activeTab === "Payment-Details" && <PaymentDetailsTab />}
                {activeTab === "Referral" && <Referral />}
                {activeTab === "Agreements" && <AgreementTab />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfilePage;
